import { ROLE_GROUPS, type RoleGroup } from '@/constants/roles'

export const hasRoleFromGroup = (
  roles: readonly string[] | null | undefined,
  group: RoleGroup
) => {
  const groupRoles: readonly string[] = ROLE_GROUPS[group]
  return !!roles?.some((role) => groupRoles.includes(role))
}
